import Shariff from 'shariff';
import { CONFIG, BREAKPOINTS_NUMERIC } from '../config';

class SocialShareButtons {
  constructor(options = {}) {
    this.$root = options.element;
  }

  init() {
    this.socialMediaInit();
    this.whatsappInit();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener(CONFIG.events.VIEWPORT_CHANGED, () => this.whatsappInit());
  }

  /**
   * Use Shariff plugin for social sharing buttons;
   *    initialize services (facebook, ...)
   */
  socialMediaInit() {
    const services = this.$root.getAttribute('data-services').split(',');
    const infoUrl = this.$root.getAttribute('data-info-url');
    const mailSubject = this.$root.getAttribute('data-mail-title');
    const mailBody = this.$root.getAttribute('data-mail-text') || '{url}';
    const title = this.$root.getAttribute('data-page-title') || document.title;
    this.$smButtonsContainer = this.$root.parentElement.querySelector('.social-sharing-buttons__button-container');

    // eslint-disable-next-line no-unused-vars
    const shariff = new Shariff(this.$smButtonsContainer, {
      mailUrl: 'mailto:',
      title,
      mailSubject,
      mailBody,
      infoUrl,
      services,
    });

    this.$whatsappATag = this.$smButtonsContainer.querySelector('li.whatsapp a');
  }

  /**
   * Switches between urls for whatsapp app and whatsapp web depending on the viewport size
   */
  whatsappInit() {
    if (this.$whatsappATag) {

      this.$whatsappATag.innerHTML = this.$whatsappATag.innerHTML.replace('teilen', 'whatsapp');

      if (window.innerWidth > BREAKPOINTS_NUMERIC.medium) {

        this.$whatsappATag.href =
          this.$whatsappATag.href.replace('whatsapp://send?text=', 'https://web.whatsapp.com/send?text=');
        this.$whatsappATag.target = '_blank';

      } else {

        this.$whatsappATag.href =
          this.$whatsappATag.href.replace('https://web.whatsapp.com/send?text=', 'whatsapp://send?text=');
        this.$whatsappATag.removeAttribute('target');

      }

    }
  }

}

export default SocialShareButtons;



// WEBPACK FOOTER //
// ./src/javascript/main/SocialShareButtons/index.js